import { KEYCLOAK_AUTH } from 'config'
import { createAuthStrategy } from 'lib/auth'
import { keycloak } from 'lib/auth/adapters'

export const { AuthProvider, useAuth } = createAuthStrategy(
  keycloak(KEYCLOAK_AUTH)
)
